export default {
  title: "Support",
  payments: "Bei allen Fragen zu Auszahlungen schreiben Sie bitte an {finance_email}.",
  spam: 'Wichtig: Bitte prüfen Sie auch Ihren "Spam"-Ordner!',
  other: "Bei allen anderen Fragen nutzen Sie bitte das untenstehende Formular.",
  faq: "häufig gestellte Fragen",
  faq_notice:
    "Bevor Sie eine Anfrage senden, lesen Sie bitte unsere Regeln und den Bereich {faq} (FAQ) — möglicherweise steht die Antwort bereits dort.",
  response_time:
    "Eine Antwort kann je nach Komplexität der Anfrage und aktueller Auslastung des Supports 12 Stunden bis 2 Werktage dauern."
};
